import {
    Box,
    Checkbox,
    ListItemText,
    MenuItem,
  Typography,
  FormControl,
  InputLabel,
  Select
} from "@mui/material";
import { useIntl } from "react-intl";
import ORDER_STATUSES from "../helpers/orderCategories";
import ORDER_ROW_TYPE_META from "../helpers/types";

import SettingsPopupMenu from "./SettingsPopupMenu";



const PERIOD_PRESETS = {
    ALL: "all",
    LAST_7_DAYS: "last7",
    LAST_30_DAYS: "last30",
    CUSTOM: "custom",
};

const sectionTitleSx = {
    fontSize: 10,
    fontWeight: 700,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "text.disabled",
};

const FilterSettingsPanel = ({
  anchorEl,
  open,
  onClose,
  filters,
  statuses,
  onToggleType,
  onToggleStatus,
  onClearStatuses,
  onOrderStatusChange,
}) => {
  const intl = useIntl();

  

  return (
    <SettingsPopupMenu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      title={intl.formatMessage({ id: "incomingOrders.views.filtering" })}
      subtitle={intl.formatMessage({ id: "incomingOrders.views.selectFiltersHelp" })}
    >
      <Box sx={{ px: 2, pt: 0.25, pb: 0.5 }}>
        <Typography sx={{ fontSize: 10, fontWeight: 700 }}>
          {intl.formatMessage({ id: "incomingOrders.views.productType" })}
        </Typography>
      </Box>

      {Object.entries(ORDER_ROW_TYPE_META).map(([key, type]) => (
        <MenuItem key={key} dense onClick={() => onToggleType(key)}>
          <Checkbox
            size="small"
            checked={filters.productTypes.includes(key)}
          />
          <ListItemText primary={`${type.icon} ${type.label}`} />
        </MenuItem>
      ))}

      <Box sx={{ px: 2, pb: 1 }}>
        <FormControl fullWidth size="small">
          <InputLabel>Orderstatus</InputLabel>

          <Select
            value={filters.orderStatus ?? ""}
            label="Orderstatus"
            onChange={(event) =>
              onOrderStatusChange(event.target.value || null)
            }
            MenuProps={{
              disablePortal: true,
            }}
          >
            <MenuItem value="">
              Alla
              </MenuItem>

            {ORDER_STATUSES.map((status) => (
              <MenuItem
                key={status.key}
                value={status.key}
              >
                {status.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <Box sx={{ borderTop: "1px solid", borderColor: "divider", mt: 1, pt: 1 }}>
        <Box sx={{ px: 2, pb: 0.5 }}>
          <Typography sx={{ fontSize: 10, fontWeight: 700 }}>
            {intl.formatMessage({ id: "incomingOrders.views.orderStatus" })}
          </Typography>
        </Box>
             

        <MenuItem
          dense
          onClick={onClearStatuses}
          disabled={filters.supplierOrderStatusIds.length === 0}
        >
          <Checkbox
            size="small"
            checked={filters.supplierOrderStatusIds.length === 0}
            indeterminate={filters.supplierOrderStatusIds.length > 0}
          />
          <ListItemText primary={intl.formatMessage({ id: "incomingOrders.toolbar.allStatuses" })} />
        </MenuItem>

        {statuses && statuses.map((status) => {
          const checked = filters.supplierOrderStatusIds.includes(status.id);

          return (
            <MenuItem
              key={status.id}
              dense
              onClick={() => onToggleStatus(status.id)}
            >
              <Checkbox size="small" checked={checked} />
              <ListItemText primary={status.name} />
            </MenuItem>
          );
        })}
      </Box>
    </SettingsPopupMenu>
  );
};

export default FilterSettingsPanel;